import React from 'react'
import ReactHls from 'react-hls';

import { modal } from '../../core/utilities/modal'
import { buildingCameras } from '../../core/controllers/BuildingCameras'

export default class BuildingCamera extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: this.props.name,
            id: this.props.id,
            level: this.props.level,
            rtsp: '',
            isEditing: false
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    componentDidUpdate() {
    }

    deleteCamera(id) {
        var self = this;
        modal.showDangerModalWithOK("Are you sure?","You are about to delete this camera.","Yes, Delete");
        jQuery(".move-on").on('click',function() {
            buildingCameras.deleteCamera(id, function(response) {
                if(response.data.error) {
                    modal.showInfo("Failed to delete camera.", "danger", "top", "center");
                } else {
                    modal.showInfo("Camera was deleted", "success", "top", "center");
                    self.props.checkCameras(true);
                }
            });
        });
    }

    startEditing() {
       this.setState({
           isEditing: true
       });
    }

    handleNameChange(e) {
        this.setState({
            name: e.target.value
        });
    }

    editCamera() {
        var self = this;
        const name = this.state.name;
        const id = this.state.id;
        const level = this.state.level;
        modal.showDangerModalWithOK("Are you sure?","You are about to update this camera.","Yes, Update");
        jQuery(".move-on").on('click',function() {
            buildingCameras.updateCamera(id, name, function(response) {
                if(response.data.error) {
                    modal.showInfo("Failed to update camera.", "danger", "top", "center");
                } else {
                    modal.showInfo("Camera was updated!", "success", "top", "center");
                    self.props.checkCameras(true);
                }
            });
        });
    }

    cancelEditCamera() {
        this.setState({
            isEditing: false
        });
    }

    render(){
        const name = this.state.name;
        const id = this.state.id;
        const level = this.state.level;
        const rtsp = this.state.rtsp;
        const isEditing = this.state.isEditing;
        return (
            <div key={this.props.key}>
                <hr></hr>
                <h5 class="title">
                    <i class="pe-7s-plug"></i>
                    <small><i class="pe-7s-angle-right"></i></small> {name} - Level {level}
                </h5>
                <div class="legend">
                </div>
                { isEditing == true ? (
                    <div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="password">Name</label>
                                <input type="text" value="" class="form-control" placeholder="Front Office" id="name" value={name} onChange={this.handleNameChange.bind(this)}/>
                            </div>
                        </div>
                        <div class="sensors-container">
                            <button type="button" id="play-video" class="btn btn-secondary btn-info btn-fill" onClick={this.editCamera.bind(this)}>Update Camera</button>
                            <button type="button" id="edit-video" class="btn btn-warning btn-info btn-fill" onClick={this.cancelEditCamera.bind(this)}>Cancel</button>
                        </div>
                    </div>
                ) : (
                    <div class="sensors-container">
                        <button type="button" id="play-video" class="btn btn-secondary btn-info btn-fill" onClick={this.props.playVideo.bind(this, id)}>Play Feed</button>
                        <button type="button" id="edit-video" class="btn btn-warning btn-info btn-fill" onClick={this.startEditing.bind(this)}>Edit Camera</button>
                        <button type="button" id="delete-camera" class="btn btn-danger btn-info btn-fill" onClick={this.deleteCamera.bind(this, id)}>Delete Camera</button>
                    </div>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingCamera.jsx